import { Controller } from '@hotwired/stimulus'

// Sub-seasonality in de kaart "Verdeling over queues" op de Forecaster. De
// schakelaar Standard/Recent zet het weken-veld aan of uit: een uitgeschakeld
// veld gaat niet mee met het formulier en wordt ook niet gevalideerd (een
// verborgen, ongeldig veld zou het opslaan anders stil blokkeren). Na het
// opslaan komt de pagina terug met ?tab=queue-share en scrolt hij naar deze
// kaart. Geen #anker: dat laat Turbo weg bij de redirect na een formulier.
export default class extends Controller {
  static targets = ['toggle', 'weeks', 'weeksBox', 'hintStandard', 'hintRecent']

  connect () {
    this.sync()
    if (new URL(window.location.href).searchParams.get('tab') === 'queue-share') {
      // Na het renderen scrolt Turbo zelf nog naar boven, en dat komt ná
      // connect(); een scroll hier werd dus meteen teruggedraaid. Een macrotaak
      // later is Turbo klaar.
      setTimeout(() => {
        const card = document.getElementById('queue-share')
        if (card) card.scrollIntoView({ block: 'start' })
      }, 0)
    }
  }

  sync () {
    const recent = this.toggleTarget.checked
    this.weeksTarget.disabled = !recent
    this.weeksBoxTarget.hidden = !recent
    if (this.hasHintStandardTarget) this.hintStandardTarget.hidden = recent
    if (this.hasHintRecentTarget) this.hintRecentTarget.hidden = !recent
  }
}
